define("settings/controllers/overview/two-factor", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch"], function (_exports, _asyncArrowRuntime, _controller, _object, _computed, _service, _tracking, _emberConcurrency, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _confirmClose;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let TwoFactorController = _exports.default = (_dec = (0, _computed.reads)('auth.currentUserModel.otp_required_for_login'), _dec2 = (0, _computed.reads)('auth.currentUserModel.unconfirmed_two_factor'), _dec3 = (0, _computed.reads)('auth.currentUserModel'), (_class = (_confirmClose = /*#__PURE__*/new WeakSet(), class TwoFactorController extends _controller.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _confirmClose);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "router", _descriptor5, this);
      _initializerDefineProperty(this, "store", _descriptor6, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor7, this);
      _initializerDefineProperty(this, "otp_required", _descriptor8, this);
      _initializerDefineProperty(this, "unconfirmed_two_factor", _descriptor9, this);
      _initializerDefineProperty(this, "user", _descriptor10, this);
      _defineProperty(this, "qrCodeClassName", 'e--qr__code');
      _initializerDefineProperty(this, "backupCodes", _descriptor11, this);
      _initializerDefineProperty(this, "errorMessage", _descriptor12, this);
      _initializerDefineProperty(this, "otp", _descriptor13, this);
      _initializerDefineProperty(this, "qrCodeUrl", _descriptor14, this);
      _defineProperty(this, "confirm", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (secret) {
          this.errorMessage = null;
          try {
            const {
              user,
              backup_codes
            } = yield (0, _fetch.fetch)(`/api/v2/users/confirm_two_factor.json`, {
              method: 'PATCH',
              body: {
                user: {
                  otp_attempt: secret
                }
              }
            });
            this.backupCodes = backup_codes;
            this.store.pushPayload(user);
            this.auth.refresh();
            this.alerts.success(this.intl.t('alerts.account.two_factor.setup_complete'));
          } catch (error) {
            if (error.message.title) {
              if (!this.otp) {
                this.errorMessage = this.intl.t('alerts.account.two_factor.error_no_code');
              } else {
                this.errorMessage = this.intl.t('alerts.account.two_factor.error_incorrect_code');
              }
            }
          }
        }
      }), null, "confirm", null));
    }
    async setup() {
      try {
        const blob = await (0, _fetch.fetch)(`/api/v2/users/setup_two_factor`, {
          method: 'PATCH'
        });
        this.qrCodeUrl = URL.createObjectURL(blob);
      } catch (error) {
        this.errors.log(error);
      }
    }
    closeModal() {
      if (this.backupCodes) {
        this.dialogManager.confirm(this.intl.t('account.two_factor.confirm_backup_code')).then(() => _classPrivateMethodGet(this, _confirmClose, _confirmClose2).call(this));
      } else {
        _classPrivateMethodGet(this, _confirmClose, _confirmClose2).call(this);
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "otp_required", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "unconfirmed_two_factor", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "backupCodes", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "errorMessage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "otp", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "qrCodeUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  function _confirmClose2() {
    this.backupCodes = null;
    this.errorMessage = null;
    this.otp = null;
    this.qrCodeUrl = null;
    this.router.transitionTo('account.overview');
  }
});